import { gql } from '@apollo/client';

export default gql`
query GetGenre($IdGenero: ID!) {
  Genre(IdGenero: $IdGenero) {
    IdGenero
    Genero
  }
}
`;